import React from 'react';
import Text from '../../../global/text/text';
import { IAccountGroupDTO } from '../../../../api/account-groups.dao';
import DefaultButton from '../../../global/default-button/default-button';
import classnames from 'classnames';
import { Permission } from '../../../../api/roles.dao';
import { hasPermission } from '../../../../infrastructure/utils/has-permissions';
import { editText } from '../../../../constants/common-labels.constants';

const AccountGroupsListItem = (
    props: IAccountGroupDTO & {
        handleEditGroupClick: (groupId: number) => void;
        isGroupSelected?: boolean;
    }
) => {
    const { name, description, handleEditGroupClick, isGroupSelected } = props;

    const groupEffectClasses = classnames({
        active: isGroupSelected,
        hoverable: !isGroupSelected,
    });

    const handleEditClick = (): void => {
        handleEditGroupClick(props.accountGroupId);
    };

    return (
        <tr className='role-item' onDoubleClick={hasPermission(Permission.EDIT_ACCOUNT_GROUP_LIST) ? handleEditClick : undefined}>
            <td className={groupEffectClasses}>
                <div className='role-item__column role-item__name'>
                    <div className='role-item__name-content'>
                        <Text className='role-item__text' message={name} withEllipsis />
                    </div>
                    { hasPermission(Permission.EDIT_ACCOUNT_GROUP_LIST) &&
                        <DefaultButton
                            className='visible-while-hovered'
                            modifier={['slim', 'link']}
                            text={editText()}
                            onClick={handleEditClick}
                        />
                    }
                </div>
            </td>
            <td className={groupEffectClasses}>
                <div className='role-item__column role-item__description'>
                    <div className='role-item__description-content'>
                        <Text className='role-item__text' message={description} withEllipsis />
                    </div>
                </div>
            </td>
        </tr>
    );
};

export { AccountGroupsListItem };
